import React from 'react';
import { FooterStyles } from './FooterStyles';
import FacebookIcon from '../../assets/icons/FacebookIcon';
import InstagramIcon from '../../assets/icons/InstagramIcon';
import Logo from '../../assets/icons/Logo';
import { Link } from 'react-router-dom';
import { navigationData } from '../../constants';
import { useAppSelector } from '../../state/hooks';
import { translations } from '../../i18n/translations';
import TelegramIcon from '../../assets/icons/TelegramIcon';

function Footer() {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <FooterStyles>
      <div className="container">
        <div className="content">
          <div className="logoAndTermsWrapper">
            <div className="logoContainer">
              <Logo />
              <div className="socialLinksContainer">
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <a href="https://www.facebook.com/RealistHub/" target="_blank" rel="noreferrer"><FacebookIcon /></a>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <a href="https://www.instagram.com/realist_hub/" target="_blank" rel="noreferrer"><InstagramIcon /></a>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <a href="https://t.me/realist_hub" target="_blank" rel="noreferrer"><TelegramIcon /></a>
              </div>
            </div>

            <div className="termsContainer">
              <span className="textSemiBold textBase16">Realist Security HUB</span>
              <span className="textSemiBold textBase16">
                © 2022
                {' '}
                {translations[interfaceLanguage].footers_terms}
              </span>
            </div>
          </div>

          <div className="listWrapper">
            <div className="head">
              <span className="title textSemiBold textBase18">{translations[interfaceLanguage].footer_list_title}</span>

              <ul>
                {/* eslint-disable-next-line react/no-array-index-key */}
                {navigationData(interfaceLanguage).map((item, index) => <li className="textSemiBold textBase16" key={index}><Link to={`/${interfaceLanguage}${item.path}`}>{item.name}</Link></li>)}
              </ul>
            </div>

            <Link to={`/${interfaceLanguage}/public-service-contract`} className="link textSemiBold textBase16">{translations[interfaceLanguage].footer_offerta}</Link>
          </div>

          <div className="contactsWrapper">
            <div className="head">
              <span className="title textSemiBold textBase18">{translations[interfaceLanguage].footer_address}</span>

              <div className="contactsLinks">
                <a className="textSemiBold textBase16" href="https://goo.gl/maps/cGQLopz6fwPakbb96" target="_blank" rel="noreferrer">
                  {translations[interfaceLanguage].footer_contacts}
                </a>

                <a className="textSemiBold textBase16" href="tel:+380969571111">+38 096 957-11-11</a>

                <a className="textSemiBold textBase16" href="mailto:realist.hub@gmail.com">realist.hub@gmail.com</a>
              </div>
            </div>

            <Link to={`/${interfaceLanguage}/privacy-policy`} className="privacyPolicyLink textSemiBold textBase16">{translations[interfaceLanguage].footer_privacy_policy}</Link>
          </div>

          <div className="splitterMobile" />

          <div className="termsMobileWrapper">
            <div className="termsMobile">
              <span className="textSemiBold textBase16">Realist Security HUB</span>
              <span className="textBase16">
                © 2022
                {' '}
                {translations[interfaceLanguage].footers_terms}
              </span>
            </div>

            <Link to={`/${interfaceLanguage}/public-service-contract`} className="textSemiBold textBase16">{translations[interfaceLanguage].footer_offerta}</Link>
            <Link to={`/${interfaceLanguage}/privacy-policy`} className="textSemiBold textBase16">{translations[interfaceLanguage].footer_privacy_policy}</Link>
          </div>

        </div>
      </div>
    </FooterStyles>
  );
}

export default Footer;
